<template>
  <div>
    <table
      class="levels-table table table-striped table-bordered table-sticky table-sm"
    >
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Name</th>
          <th scope="col">Difficulty</th>
          <th scope="col">Average turns</th>
          <th scope="col">Average winner turns</th>
          <th scope="col">Fail rate w/ boostres</th>
          <th scope="col">Fail rate w/o boostres</th>
          <th scope="col">Average fails w/ boosters</th>
          <th scope="col">Average fails w/o boosters</th>
          <th scope="col">Average fails before win</th>
          <th scope="col">Average used money total</th>
          <th scope="col">Pass rate</th>
          <th scope="col">Sacrifice ratio</th>
          <th scope="col">Conversion into payer</th>
          <th scope="col">Monetization quality</th>
          <th scope="col">Boosters usage rate</th>
          <th scope="col">Coolness factor</th>
          <th scope="col">Players</th>
          <th scope="col">Winners</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="level in levels">
          <tr
            v-for="(revision, index) in level.revisions"
            :key="revision.id.protoId"
            :class="[level.revisions.length > 1 ? 'ab-test-group': 'common', level.revisions.length > 1 && index == 0 ? 'first' : '', level.revisions.length > 1 && index == level.revisions.length-1 ? 'last' : '']"
          >
            <td
              class="level-number"
              v-if="index == 0"
              :rowspan="level.revisions.length"
            >
              <level-link :levelId="revision.id" :audienceId="revision.stat.audienceId | zeroToNull">
                {{level.number}}
              </level-link>
            </td>
            <td>
              <level-var-link :levelVarId="revision.id" :audienceId="revision.stat.audienceId | zeroToNull">
                {{revision.levelProtoName.replace('@m3/levels/', '') }}
              </level-var-link>
            </td>
            <td>{{revision.difficulty | getDifficultyShortName}}</td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.averageTurnAmount) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.averageWinnerTurnAmount) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(revision.stat.FailRate.WithBoosters) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(revision.stat.FailRate.WithoutBoosters) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.AverageFails.WithBoosters) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.AverageFails.WithoutBoosters) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.averageFailAmountBeforeFirstWin)}} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.averageUsedMoneyTotal)}} </td>

            <td
              class="text-nowrap text-monospace text-right"
              :style="{ 'background-color': getPassRateColor(revision.stat.PassRate * 100, revision.difficulty, minPassRateConfs) }"
            >
              {{ formatValueAsPercent(revision.stat.PassRate) }}
            </td>

            <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(revision.stat.sacrificeRatio) }}</td>
            <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(revision.stat.payerConversion) }}</td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.MonetizationQuality) }}</td>
            <td class="text-nowrap text-monospace text-right">{{ formatValueAsPercent(revision.stat.extraUsageRate) }} </td>
            <td class="text-nowrap text-monospace text-right">{{ formatValue(revision.stat.CoolnessFactor) }}</td>
            <td class="text-nowrap text-monospace text-right">{{ revision.stat.TotalPlayers | getFormattedNumber }}</td>
            <td class="text-nowrap text-monospace text-right">{{ revision.stat.PassedPlayers | getFormattedNumber }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getDifficultyShortName      } from '../../model/m3level.js';
import { getPassRateColor } from '../../model/m3level.js';

import { zeroToNull } from '../../util.js';

import LevelLink from './LevelLink.vue';
import LevelVarLink from './LevelVarLink.vue';

export default {
  name: 'RevisionsView',

  components: {
    LevelLink,
    LevelVarLink,
  },

  props: {
    levels: {
      type: Array,
      required: true,
    },

    minPassRateConfs: {
      type: Array,
      default: null,
    },
  },

  methods: {
    formatValueAsPercent(value, fractionDigits) {
      return this.formatValue(value * 100, fractionDigits);
    },

    formatValue(value, fractionDigits) {
      const digits = (fractionDigits === null || fractionDigits === undefined) ? 2 : fractionDigits;
      const number = Number.parseFloat(value).toFixed(digits);
      return number;
    },

    getPassRateColor,
  },

  filters: {
    getDifficultyShortName,
    zeroToNull,
  },
}
</script>

<style scoped>
.levels-table {
  max-width: 600px;
}

.levels-table th {
  text-align: center;
}

.table-sticky {
  position: relative;
  border-collapse: collapse;
}

.table-sticky th {
  background-color: white;
  position: sticky;
  top: 0;
  border: 1px solid #dee2e6;
}

table td:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.1);
}

.ab-test-group.first td.level-number {
  vertical-align: top;
}
.table-striped tbody tr.ab-test-group:nth-of-type(odd) td {
  background-color: #c9d3e6;
}
.table-striped tbody tr.ab-test-group:nth-of-type(even) td {
  background-color: #b2bcd0;
}
</style>